import React, { useState } from 'react';
import { IPricingPlan } from "components/pricing/Plan";
import Icon from "components/elements/Icon";
import { IFeature } from "components/pricing/Features/Features";
import MobileFeatures from "components/pricing/Features/MobileFeatures";
import DesktopFeatures from "components/pricing/Features/DesktopFeatures";
import Text from "components/typography/Text";

type Props = {
    features: IFeature[],
    plans: IPricingPlan[],
    name: string,
    categories: string[],
    isExpended: boolean
};

export default function FeaturesCategory(props: Props) {
    const { name, plans, features, categories, isExpended } = props;
    const [isExpanded, setExpanded] = useState(isExpended);

    const planHasFeature = (plan: string, feature: IFeature) => {
        let hasFeature = false;

        feature.plans?.forEach((p) => {
            if (p.name == plan) {
                hasFeature = true;
            }
        });

        return hasFeature;
    };

    return (
        <div className={"border-b-2 border-primary-50 py-3  text-lg lg:border-b-0 lg:py-0"}>
            <div className={`lg:flex`}>
                <div
                    className={"flex items-center space-x-2 lg:cursor-pointer lg:my-4"}
                    onClick={() => setExpanded(!isExpanded)}
                >
                    <Text
                        weight={'normal'}
                        size={'md'}
                        color={'text-gray-900'}
                    >
                        {name}
                    </Text>
                    <Icon
                        url={"/static/icons/chevron-right.svg"}
                        className={`stroke-current bg-gray-900 ${isExpanded && "rotate-90"} transition-all transform`}
                        size={"extra-small"}
                    />
                </div>
                <div className={"hidden lg:flex lg:flex-1 lg:justify-end select-none"}>
                    {plans.map((plan) => (
                        <div
                            className={`2xl:w-72 lg:w-64 px-1 transform ease-out-in duration-700 ${(plan.mostPopular) ? 'bg-primary-25 last:bg-blue' : 'bg-white'}`}
                            key={plan.id}
                        > &nbsp;</div>
                    ))}
                    {/*<div className={"2xl:w-56 w-44 px-1"}>&nbsp;</div>*/}
                    {/*<div className={`${isExpanded ? 'white' : ''} 2xl:w-56 w-44 px-1`}>&nbsp;</div>*/}
                    {/*<div className={"2xl:w-56 w-44 px-1"}>&nbsp;</div>*/}
                </div>
            </div>

            <div>
                {isExpanded && (
                    <MobileFeatures features={features} plans={plans} planHasFeature={planHasFeature}/>
                )}
            </div>

            <div
                className={`overflow-hidden transform transition-height ease-in-out duration-700`}
                style={isExpanded ? { maxHeight: "100rem" } : { maxHeight: "0px" }}
            >
                <DesktopFeatures features={features} plans={plans} planHasFeature={planHasFeature}/>
            </div>

        </div>
    );
}